module.exports = __webpack_public_path__ + "static/boyDog-8198521e256456cce41ee01b5bac10e8.jpg";